<template>
  <div>
    <b-row>
      <b-col>
        <find-or-create-contact-form
          ref="findOrCreateContactForm"
          search-label="Shareholder name"
          v-model="recipientId"
          :accountId="accountId"
        ></find-or-create-contact-form>
      </b-col>

      <b-col>
        <base-input label="Share class" name="Share class">
          <select class="form-control" v-model="shareClassId">
            <option
              :value="shareClass.id"
              v-for="shareClass in shareClasses"
              :key="shareClass.id"
              >{{ shareClass.name | decode }}</option
            >
          </select>
        </base-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <base-input
          label="Allotment Date"
          name="Allotment Date"
          type="date"
          v-model="date"
        ></base-input>
      </b-col>

      <b-col>
        <base-input type="number" v-model="numberOfShares" min="1">
          <label class="form-control-label" slot="label">
            Shares
            <i
              class="fa fa-question-circle ml-1"
              v-b-tooltip.hover
              title="Number of shares"
            ></i>
          </label>
        </base-input>
      </b-col>

      <b-col>
        <base-input
          type="text"
          v-model="recipientLedgerNumber"
          :disabled="recipientLedgerNumberEntryDisabled"
        >
          <label class="form-control-label" slot="label">
            Ledger
            <i
              class="fa fa-question-circle ml-1"
              v-b-tooltip.hover
              title="Shareholder ledger number"
            ></i>
          </label>
        </base-input>
      </b-col>
    </b-row>
    <b-row>
      <!-- TODO: fully paid up (switch / checkbox) -->
      <!-- partially paid up amount (if applicable) -->
    </b-row>
    <b-row>
      <b-col cols="12" sm="6">
        <b-btn @click="$emit('cancel')" variant="outline-secondary" block>
          <i class="fa fa-times mr-2"></i> Cancel
        </b-btn>
      </b-col>
      <b-col cols="12" sm="6">
        <b-btn @click="create" variant="success" block>
          <span v-if="!creating">
            Save
            <i class="fa fa-arrow-right ml-2"></i>
          </span>
          <span v-else>
            <i class="fa fa-spin fa-spinner mr-2"></i> Please wait&hellip;
          </span>
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import FindOrCreateContactForm from "../../Contacts/FindOrCreateContactForm";
import { get } from "dot-prop";
import _ from "underscore";

export default {
  name: "share-allotment-create-form",
  components: {
    FindOrCreateContactForm
  },
  props: {
    accountId: {
      type: String,
      description: "Account ID",
      required: true
    },
    companyId: {
      type: String,
      description: "Company ID",
      required: true
    },
    companyIncorporationDate: {
      type: String,
      description: "Company Incorporation Date",
      required: false
    },
    currency: {
      type: String,
      description: "ISO Currency Code",
      required: true
    },
    shareClasses: {
      type: Array,
      description: "Share classes",
      required: true
    },
    shareholders: {
      type: Array,
      description: "Shareholders",
      required: true
    }
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        // focus on input
        this.$refs.findOrCreateContactForm.setFocus();
      });
    },
    setDefaultRecipientLedgerNumber() {
      const nextLedgerNumber = this.shareholders.length + 1;
      this.recipientLedgerNumber = nextLedgerNumber.toString().padStart(3, "0");
    },
    create() {
      this.creating = true;
      const requestBody = {
        type: "allotment",
        shareClassId: this.shareClassId,
        recipientId: this.recipientId,
        date: this.date,
        recipientLedgerNumber: this.recipientLedgerNumber,
        numberOfShares: this.numberOfShares,
        fullyPaidUp: this.fullyPaidUp
      };

      this.axios
        .post(
          `/v1/accounts/${this.accountId}/companies/${this.companyId}/share-movements`,
          requestBody
        )
        .then(response => {
          this.creating = false;
          if (response.data) {
            const shareMovement = response.data;
            this.$emit("share-movement-created", shareMovement);
          }

          this.$notify({
            message: "Share movement created",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success"
          });
        })
        .catch(error => {
          this.creating = false;
          this.errorMessage = "Failed to create share movement";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  },
  data() {
    return {
      recipientId: null,
      shareClassId: null,
      recipientLedgerNumber: null,
      recipientLedgerNumberEntryDisabled: false,
      creating: false,
      errorMessage: null,
      date: moment().format("YYYY-MM-DD"),
      numberOfShares: 1,
      fullyPaidUp: true
    };
  },
  watch: {
    recipientId(newVal, oldVal) {
      if (newVal) {
        // check if recipient is already a shareholder
        const existingShareholder = _.findWhere(this.shareholders, {
          id: newVal
        });
        if (existingShareholder) {
          this.recipientLedgerNumber = existingShareholder.ledgerNumber;
          this.recipientLedgerNumberEntryDisabled = true;
        } else {
          this.recipientLedgerNumberEntryDisabled = false;
          this.setDefaultRecipientLedgerNumber();
        }
      } else {
        this.recipientLedgerNumberEntryDisabled = false;
        this.setDefaultRecipientLedgerNumber();
      }
    }
  },
  created() {
    if (this.shareClasses.length) {
      this.shareClassId = this.shareClasses[0].id;
    }

    // set default recipient ledger number
    this.setDefaultRecipientLedgerNumber();

    // set allotment date to company incorporation date if no shareholders
    if (this.shareholders.length < 1) {
      this.date = this.companyIncorporationDate;
    }
  }
};
</script>
